import { Cuisine } from '@/types/cuisine';
import { CuisineWire } from '../schemas/cuisine';

/**
 * Convert wire cuisine format (backend) to domain cuisine format (app).
 * ISO strings -> Unix ms, 0/1 -> boolean, null -> undefined.
 * Returns a new object; never mutates the input.
 */
export function mapCuisineWireToDomain(wire: CuisineWire): Cuisine {
  return {
    id: wire.id,
    name: wire.name,
    slug: wire.slug,
    description: wire.description ?? undefined,
    isCurated: wire.is_curated === 1,
    createdAt: new Date(wire.created_at).getTime(),
    updatedAt: new Date(wire.updated_at).getTime(),
  };
}
